import TTable from './table.vue'
import TTableColumn from './table-column'

/* istanbul ignore next */
TTable.install = function(Vue) {
  Vue.component(TTable.name, TTable)
}
TTableColumn.install = function(Vue) {
  Vue.component(TTableColumn.name, TTableColumn)
}

export { TTable, TTableColumn }



// WEBPACK FOOTER //
// ./src/module/table/index.js